const MIN_ZOOM = 3;
const SINGLE_PIN_ZOOM = 13;
const DEFAULT_PLACEMARK_SIZE = [60, 72];
const DEFAULT_PLACEMARK_OFFSET = [-30, -36];
const DEFAULT_CLUSTER_SIZE = [56, 56];
const DEFAULT_CLUSTER_RADIUS = 60;
const DEFAULT_CLUSTER_MAX_ZOOM = 18;
const MAP_CONTAINER_STYLE = {
  width: "100%",
  height: "100%"
};
export {
  DEFAULT_CLUSTER_MAX_ZOOM,
  DEFAULT_CLUSTER_RADIUS,
  DEFAULT_CLUSTER_SIZE,
  DEFAULT_PLACEMARK_OFFSET,
  DEFAULT_PLACEMARK_SIZE,
  MAP_CONTAINER_STYLE,
  MIN_ZOOM,
  SINGLE_PIN_ZOOM
};
//# sourceMappingURL=constants.js.map
